import moment from "moment";
import _ from "lodash-es";

function mapServerMsgToYunXin(rds) {
	let lastMsg = undefined;
	return rds.map(r => {
		const from = r.isFromCustomer === "Y" ? r.customerAccid : r.userAccid;
		const fromNick = r.isFromCustomer === "Y" ? r.customerNickName : r.userNickName;
		const to = r.isFromCustomer === "Y" ? r.userAccid : r.customerAccid;
		const text = r.sendtype === "0" ? r.content : undefined;
		const file = r.sendtype !== "0" ? JSON.parse(r.content) : undefined;
		const flow = r.isFromCustomer === "Y" ? "out" : "in";
		const mTime = moment(r.sendtime);
		let type = "text";
		switch (r.sendtype) {
			case "0":
				type = "text";
				break;
			case "1":
				type = "image";
				break;
			case "2":
				type = "audio";
				file.playing = false;
				break;
			case "3":
				type = "video";
				break;
			case "6":
				type = "file";
				break;
		}
		const ret = {
			"scene": "p2p",
			"from": from,
			"fromNick": fromNick,
			"flow": flow,
			"to": to,
			"type": type,
			"file": file,
			"text": text,
			"idServer": r.id,
			"idClient": `msg-${_.uniqueId()}`,
			"sessionId": r.sessionId,
			"time": mTime.unix() * 1000,
			"mTime": mTime,
			"status": "success",
		}
		if (!lastMsg || lastMsg.mTime.diff(mTime, "seconds") > 180) {
			ret.printTime = mTime.format("YYYY-MM-DD HH:mm:ss");
			lastMsg = ret;
		}
		return ret;
	});
}

export {
	mapServerMsgToYunXin
}
